import styled from 'styled-components';

export const Container = styled.div``;

export const PageBreak = styled.div`
	page-break-before: always;
`;
